import img1 from '../assets/images/servicos/1.jpg';
import img2 from '../assets/images/servicos/2.jpg';
import img3 from '../assets/images/servicos/3.jpg';
import img4 from '../assets/images/servicos/4.jpg';
import img5 from '../assets/images/servicos/5.jpg';
import img6 from '../assets/images/servicos/6.jpg';
import img7 from '../assets/images/servicos/7.jpg';
import img8 from '../assets/images/servicos/8.jpg';
import img9 from '../assets/images/servicos/9.jpg';
import img11 from '../assets/images/servicos/11.jpg';
import img12 from '../assets/images/servicos/12.jpg';
import img14 from '../assets/images/servicos/14.jpg';
import img15 from '../assets/images/servicos/15.jpg';
import img16 from '../assets/images/servicos/16.jpg';
import img17 from '../assets/images/servicos/17.jpg';
import img18 from '../assets/images/servicos/18.jpg';
import img19 from '../assets/images/servicos/19.jpg';
import img20 from '../assets/images/servicos/20.jpg';
import img21 from '../assets/images/servicos/21.jpg';
import img23 from '../assets/images/servicos/23.jpg';
import img24 from '../assets/images/servicos/24.jpg';
import img25 from '../assets/images/servicos/25.jpg';
import img26 from '../assets/images/servicos/26.jpg';
import img27 from '../assets/images/servicos/27.jpg';
import img28 from '../assets/images/servicos/28.jpg';
import img29 from '../assets/images/servicos/29.jpg';
import img31 from '../assets/images/servicos/31.jpg';
import img33 from '../assets/images/servicos/33.jpg';
import img34 from '../assets/images/servicos/34.jpg';
import img35 from '../assets/images/servicos/35.jpg';
import img36 from '../assets/images/servicos/36.jpg';
import img37 from '../assets/images/equipe/1.jpg';
import img38 from '../assets/images/equipe/2.jpg';
import img39 from '../assets/images/equipe/3.jpg';

import video1 from '../assets/videos/1.mp4';
import video2 from '../assets/videos/2.mp4';

const assets = {
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img11,
  img12,
  img14,
  img15,
  img16,
  img17,
  img18,
  img19,
  img20,
  img21,
  img23,
  img24,
  img25,
  img26,
  img27,
  img28,
  img29,
  img31,
  img33,
  img34,
  img35,
  img36,
  img37,
  img38,
  img39,
  video1,
  video2,
};

export default assets;
